export default "__VITE_ASSET__CWmmRsov__"